// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  IMAGE_BUCKET_CREDENTIALS: {
    accessKeyId: 'AKIAY43EMSI5JKGVBZFL',
    secretAccessKey: 'eUJExuQ49HPSqq8Vqu26cvMvsm2Fxxw58Y3MfbEm',
    region: 'ap-south-1',
  },
  firebaseConfig: {
    apiKey: "AIzaSyBsKsstF6sBPDHTXjUVxy2YvwceCx986b0",
    authDomain: "sloka-stotra.firebaseapp.com",
    projectId: "sloka-stotra",
    storageBucket: "sloka-stotra.appspot.com",
    messagingSenderId: "151003420363",
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
